/**
 * Do not run Intercom in localhost
 */
import { isNotRunningLocally } from '@stilingue/st-environment-controller-utils';

if (isNotRunningLocally()) {
  //Set your APP_ID
  const APP_ID = 'cuuvmvgm';

  window.intercomSettings = {
    app_id: APP_ID
  };

  /**
   * Documentation for intercom
   * https://developers.intercom.com/installing-intercom/docs/basic-javascript
   */
  (function() {
    const w = window;
    const d = document;
    const i = function() {
      // eslint-disable-next-line prefer-rest-params
      i.c(arguments);
    };
    i.q = [];
    i.c = function(args) {
      i.q.push(args);
    };
    w.Intercom = i;
    const s = d.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `https://widget.intercom.io/widget/${APP_ID}`;
    const x = d.getElementsByTagName('script')[0];
    if (x && 'parentNode' in x) {
      x.parentNode.insertBefore(s, x);
    }
  }());
}

export function insertIntercomMetadata({
  email,
  user_hash,
  userId
} = {}) {
  if (typeof window.Intercom === 'function' && email && user_hash && userId) {
    window.Intercom('reattach_activator');
    window.Intercom('update', {
      app_id: 'cuuvmvgm',
      email,
      user_hash,
      logrocketURL: `https://app.logrocket.com/asbycy/stilingue-boilerplate/sessions?u=${userId}`
    });
    return true;
  }
  return false;
}
